'use client';


interface ProductFilterTabsProps {
  categories: string[]
  activeCategory: string
  onCategoryChange: (category: string) => void
}

export default function ProductFilterTabs({ categories, activeCategory, onCategoryChange }: ProductFilterTabsProps) {
  return (
    <div className="flex flex-wrap gap-3 justify-center mb-12">
      {categories.map((category) => (
        <button
          key={category}
          onClick={() => onCategoryChange(category)}
          className={`px-6 py-3 rounded-full text-sm font-semibold transition-all ${
            activeCategory === category
              ? 'bg-primary text-primary-foreground shadow-lg'
              : 'bg-white text-foreground border border-border hover:border-primary hover:text-primary'
          }`}
        >
          {category}
        </button>
      ))}
    </div>
  )
}